import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import localeEsAr from '@angular/common/locales/es-AR';
import { HttpInterceptorProviders } from './interceptors/interceptor-provider';
import { AuthGuard } from './guards/auth.guard';
import { MaterialModule } from './material.module';
import { FormComponent } from './components/form.component';
import { ErrorComponent } from './components/error.component';
import { ReCaptchaDirective } from './directives/recaptcha.directive';
import { SuccessComponent } from './components/success.component';
import { NavbarComponent } from './components/navbar.component';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
registerLocaleData(localeEsAr, 'es-AR');

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    FormComponent,
    ErrorComponent,
    NavbarComponent,
    SuccessComponent,
    ReCaptchaDirective
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
		NgxIntlTelInputModule
  ],
  providers: [
    AuthGuard,
    HttpInterceptorProviders,
    {provide: LOCALE_ID, useValue: 'es-AR'},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
